import type { SubjectsType, SplitType } from '@aytm/app/insights/dashboard/models/types.ClientDTO'
import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'
import type { BlockModelShape } from '@aytm/app/insights/dashboard/models/BlockModel'
import { compareTuples } from '@aytm/app/insights/dashboard/lib/comparison'

export type StateSelectorParams = {
  subjects: SubjectsType
  dataFiltered: boolean
  splits: SplitType[] | null
  currentSplit: string | null
  trackTarget: string
  showSigtest: boolean
  filteredRowAverages: BlockModelShape['filteredRowAverages']
  isSharedView: boolean
}

export const stateSelector = (state: InsightsDashboardPoolState): StateSelectorParams => {
  const subjects = state.currentData?.subjects || {}
  const dataFiltered = state.currentData?.dataFiltered || false
  const splits = state.currentData?.splits || null
  const block = getCurrentBlock(state)
  const currentSplit = block?.get<string>('currentSplit') || null
  const trackTarget = block?.get<string>('trackTarget') || 'entity'
  const showSigtest = block?.get<boolean>('showSigtest') || false
  const filteredRowAverages = block?.get<boolean>('filteredRowAverages') || false
  const isSharedView = state.isSharedView || false
  return {
    subjects,
    dataFiltered,
    splits,
    currentSplit,
    trackTarget,
    showSigtest,
    filteredRowAverages,
    isSharedView
  }
}

// TC-IP-EDIT.24 — extra-column Editor/Selector is shown only when:
//   the column is the extra (add) slot, no split is active, and we're tracking entities.
export function shouldRenderExtraColumnEditor(params: {
  isExtraColumn: boolean
  currentSplit: string | null
  trackTarget: string
}): boolean {
  return params.isExtraColumn && !params.currentSplit && 'entity' === params.trackTarget
}

export const shouldUpdate = (prev: StateSelectorParams, next: StateSelectorParams) =>
  !prev && !next
    ? false
    : (!prev && Boolean(next)) ||
      (Boolean(prev) && !next) ||
      !compareTuples(
        ({
          subjects,
          dataFiltered,
          splits,
          currentSplit,
          trackTarget,
          showSigtest,
          filteredRowAverages,
          isSharedView
        }) => [
          subjects,
          dataFiltered,
          splits,
          currentSplit,
          trackTarget,
          showSigtest,
          filteredRowAverages,
          isSharedView
        ]
      )(prev, next)
